import React, { useCallback, useEffect, useState } from 'react';
import { AppModal } from '@/layout/AppComponents';
import axios from 'axios';
import { useSelector } from "react-redux";
import ModuleSelectMap from './ModuleSelectMap';
import { axiosPath } from '@/routing/helpers/router'; 
import AppLink from '@/routing/helpers/AppLink';

const ModuleSelectMapBlock = (props) => {
  const { map } = props;
  const global = useSelector((state) => state.global);
  const [showMarkerModal, setShowMarkerModal] = useState();
  const [markerInfo, setMarkerInfo] = useState();
  const [markerElements, setMarkerElements] = useState();

  const handleClickMarker = (marker) => {
    setMarkerInfo(marker);
    setShowMarkerModal(true);
    setMarkerElements(undefined);
  };

  const loadMarkerElements = useCallback(async (markerID) => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_authUser_getMapElements"),
        { markerID }
      );
      return response.data;
    } catch (err) {}
  });

  useEffect(() => {
    if (markerInfo) {
      loadMarkerElements(markerInfo.id).then((r) => {
        setMarkerElements(r);
      });
    }
  }, [markerInfo]);

  return (
    <>
      <div style={{ height: '470px' }} />
      <div style={{
            position: 'absolute', top: '45px', left: 0, right: 0, height: '500px',
          }}
          >
      <ModuleSelectMap
        map={map}
        onMarkerClick={(v) => handleClickMarker(v)}
      />
      </div>
      <AppModal
        show={showMarkerModal}
        title={markerInfo?.name}
        onClose={() => { setShowMarkerModal(false); setMarkerInfo(undefined); setMarkerElements(undefined); }}
      >
        <ul>
          {markerElements?.map((e) => (
            <li key={e.id}>
              {e.type === 'p' ? (
                <AppLink
                  path="user_module_legalCompliance_evaluation"
                  params={{
                    moduleBridgeHex: e.moduleBridgeHex, plantHex: e.plantHex, page: 1, filtersHex: 0,
                  }}
                >
                  {e.name}
                </AppLink>
              ) : (
                <>
                  {e.route ? (
                    <AppLink
                      path={e.route}
                      params={{
                        moduleBridgeHex: e.moduleBridgeHex,
                      }}
                    >
                      {e.name}
                    </AppLink>
                  ) : (
                    <a href={`${global.urlData.rootProject}${e.url}`}>
                      {e.name}
                    </a>
                  )}
                </>
              )}
            </li>
          ))}
        </ul>
      </AppModal>
    </>
  );
};

export default ModuleSelectMapBlock;
